import {MarshalValue, MarshalValueData} from "./marshalValue";

export type MarshalParameters = {[key:string]: MarshalValue}
export type MarshalData = {
    action: string
    parameters: {[key:string]: MarshalValueData}
}
export class Marshal {
    public readonly action: string;
    public readonly parameters: MarshalParameters;

    constructor(data: MarshalData) {
        this.action = data.action;
        this.parameters = {};
        Object.keys(data.parameters || {}).forEach(key => {
            this.parameters[key] = new MarshalValue(data.parameters[key]);
        });
    }
    public serialise(): MarshalData {
        const serialised: MarshalData = {
            action: this.action,
            parameters: {}
        };

        Object.keys(this.parameters || {}).forEach(key => {
            serialised.parameters[key] = this.parameters[key].serialise();
        });
        return serialised;
    }
}